module.exports = __webpack_public_path__ + "static/media/mic-off-32px.725ec334.svg";